import React, { useEffect } from 'react';
import moment from 'moment';

import useGlobal from '../../../store';
import Table from '../../../facturotopia/table/Table';
import AuditStatusInfo from '../components/AuditStatusInfo';

const mapState = (store) => {
  return {
    audits: store.developer.audits.applogs,
  };
};

const mapActions = (actions) => {
  return { ...actions.developer.audits.applogs };
};

const AppLogList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state.audits;

  useEffect(() => {
    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      actions.paginate({
        page: 1,
        from,
        to,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { from = '', to = '' } = state.developer.audits.filters;

    const newMeta = {
      ...meta,
      from,
      to,
    };

    actions.paginate(newMeta);
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state.audits;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      pagination={getPaginationConfig()}
      onRowClick={onRowClick}
      onRow={(item) => {
        return {
          className: item.highlight ? 'row-highlighted' : '',
        };
      }}
    ></Table>
  );
};

const renderStatus = (item) => {
  return <AuditStatusInfo status={item.status} />;
};

const columns = [
  {
    key: 'created_at',
    title: 'Request',
    dataIndex: 'created_at',
  },
  {
    key: 'entry_type',
    title: 'Entry',
    dataIndex: 'entry_type',
  },
  {
    key: 'entity_id',
    title: 'Entity',
    dataIndex: 'entity_id',
  },
  {
    key: 'status',
    title: 'Result',
    dataIndex: 'status',
    className: 'text-center',
    render: renderStatus,
  },
  {
    key: 'time',
    title: 'Time',
    dataIndex: 'time',
  },
  {
    key: 'ip_address',
    title: 'IP',
    dataIndex: 'ip_address',
    className: 'text-center',
  },
];

export default AppLogList;
